/**
 * Renders an unordered list.
 *
 * WARNING: This component uses the item's index in the array as its key. This is not suitable if the items in the array will change (inserting items, deleting items, or reordering).
 *
 * @param {object} props
 * @param {React.ReactNode[]} props.items
 * @param {boolean} props.alwaysRenderAsList `true` to always render the `items` in a list. Otherwise, if there's only one item, the component won't render a list.
 */
function List({ items, alwaysRenderAsList, keyField }) {
    if (!items || items.length === 0) {
        return null;
    }

    return items.length > 1 || alwaysRenderAsList ? (
        <ul style={{ listStyleType: "disc", marginLeft: "18px" }}>
            {items.map((item, index) => (
                <li key={keyField ? item[keyField] : `list-item-${index}`}>{item}</li>
            ))}
        </ul>
    ) : (
        <>{items[0]}</>
    );
}

export default List;
